import { render, staticRenderFns } from "./TSVStatus.vue?vue&type=template&id=6235ce60&"
import script from "./TSVStatus.vue?vue&type=script&lang=js&"
export * from "./TSVStatus.vue?vue&type=script&lang=js&"
import style0 from "./TSVStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports